
import {throwError,  Observable } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


@Injectable()
export class HttpInterceptorService {

  constructor(private router: Router, public toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!window.navigator.onLine) {
      this.toastr.error('Подключение к Интернету отсутствует', null, { timeOut: 5000 });
      // TODO: старая версия либы ng2-toastr
      // this.toastr.error('Подключение к серверу отсутствует', null, { maxShown: 1, toastLife: 5000 });
      return throwError(new HttpErrorResponse({ error: 'Internet is required.' }));
    } else {
      let token = localStorage.getItem('token');
      if (token) {
        let dubReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
        return next.handle(dubReq).pipe(
          tap(event => {
          }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.router.navigate(['login']);
              }
              // else if (err.status === 404) {
              //   this.toastr.error('Объект не найден!', null, { maxShown: 1, toastLife: 5000 });
              // }
              else if (err.status === 409) {
              } else if (err.status >= 400 && err.status < 500 && !err.url.includes('Organizations')) {
                this.toastr.error( err.message, 'Ошибка Клиента!', { timeOut: 5000, });
              } else if (err.status >= 500 && !err.url.includes('GetOrganizationByKompra')) {
                this.toastr.error(err.message, 'Ошибка Сервера. Пожалуйста обратитесь к разработчикам!', { timeOut: 5000, });
              } else {
                // TODO: старая версия либы ng2-toastr
                // this.toastr.error('Подключение к серверу отсутствует', null, { maxShown: 1, toastLife: 5000 });
                this.toastr.error('Подключение к серверу отсутствует', null, { timeOut: 5000 });
                return;
              }
            }
          })
        );
      }
      return next.handle(req);
    }
  }

}
